// Body scroll lock shared by every modal (FormModal, ConfirmModal). Counted,
// so overlapping modals that close in any order restore the page's original
// overflow only when the last one closes. (Each modal saving and restoring
// "the previous value" itself breaks when they close out of order: a confirm
// opened over a form would put back "hidden" after the form had gone.)
let lockCount = 0;
let savedOverflow = "";

export function lockScroll() {
  if (lockCount++ === 0) {
    savedOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
  }
}

export function unlockScroll() {
  if (lockCount > 0 && --lockCount === 0) document.body.style.overflow = savedOverflow;
}
